import type { AgreementType } from './agreement.supabase.schema'

// Order matters for display in the onboarding / consent prompt.
export const REQUIRED_AGREEMENT_TYPES = ['tos', 'privacy', 'customer_agreement'] as const satisfies readonly AgreementType[]

export const EXTERNAL_AGREEMENT_URLS: Partial<Record<AgreementType, string>> = {
  tos: 'https://www.revelstreet.co/terms',
  privacy: 'https://www.revelstreet.co/privacy',
}

export const IN_APP_AGREEMENT_PATHS: Partial<Record<AgreementType, string>> = {
  customer_agreement: '/legal/customer-agreement',
}

export const AGREEMENT_TYPE_LABELS: Record<AgreementType, string> = {
  tos: 'Terms of Service',
  privacy: 'Privacy Policy',
  customer_agreement: 'Customer Agreement',
}

export const agreementTypeLink = (type: AgreementType): string =>
  EXTERNAL_AGREEMENT_URLS[type] ?? IN_APP_AGREEMENT_PATHS[type] ?? '#'

export const agreementTypeOpensInNewTab = (type: AgreementType): boolean =>
  EXTERNAL_AGREEMENT_URLS[type] !== undefined
